import React from "react";

import styles from "./VerticalDivider.module.css";

interface VerticalDividerProps {
  label?: string;
}
const VerticalDivider: React.FC<VerticalDividerProps> = (
  props: VerticalDividerProps
) => {
  return (
    <div className={styles.container}>
      <div className={styles.label}>{props.label}</div>
      <hr className={styles.divider} />
    </div>
  );
};

export default VerticalDivider;
